import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { ICreateInsurancePolicyRequest, IInsurancePolicy, IUpdateInsurancePolicyRequest } from '../interfaces/insurance.interface';

const headers = () => AuthService.getAuthHeader();

export const InsurancePolicyService = {
    list: async (institutionId: string): Promise<IInsurancePolicy[]> => {
        const res = await axios.get(ENDPOINTS.INSURANCE_POLICY.LIST(institutionId), { headers: headers() });
        return res.data;
    },

    getActive: async (institutionId: string): Promise<IInsurancePolicy | null> => {
        const res = await axios.get(ENDPOINTS.INSURANCE_POLICY.ACTIVE(institutionId), { headers: headers() });
        return res.data;
    },

    create: async (institutionId: string, request: ICreateInsurancePolicyRequest): Promise<IInsurancePolicy> => {
        const res = await axios.post(ENDPOINTS.INSURANCE_POLICY.CREATE(institutionId), request, { headers: headers() });
        return res.data;
    },

    update: async (institutionId: string, id: string, request: IUpdateInsurancePolicyRequest): Promise<IInsurancePolicy> => {
        const res = await axios.put(ENDPOINTS.INSURANCE_POLICY.UPDATE(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    activate: async (institutionId: string, id: string): Promise<IInsurancePolicy> => {
        const res = await axios.post(ENDPOINTS.INSURANCE_POLICY.ACTIVATE(institutionId, id), null, { headers: headers() });
        return res.data;
    },

    deactivate: async (institutionId: string, id: string): Promise<IInsurancePolicy> => {
        const res = await axios.post(ENDPOINTS.INSURANCE_POLICY.DEACTIVATE(institutionId, id), null, { headers: headers() });
        return res.data;
    },

    getOpenEnrollmentCount: async (institutionId: string, id: string): Promise<number> => {
        const res = await axios.get(ENDPOINTS.INSURANCE_POLICY.OPEN_ENROLLMENT_COUNT(institutionId, id), { headers: headers() });
        return res.data.count;
    },

    remove: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.INSURANCE_POLICY.DELETE(institutionId, id), { headers: headers() });
    },
};
